import { useState, useEffect, useRef } from "react";
import "./Branch.scss";
import { BiEdit, BiTrash } from "react-icons/bi";
import { useLoading } from "../../context/LoadingContext.js";
import { getallBranchNames, uploadUsersSpreadsheet } from "../../services/api/BranchApi.js";
import { useAuth } from "../../context/AuthContext.js";
import { HierarchyModal } from "../../components/HierarchyModal/HierarchyModal.js";
import CommonModal from "../../components/CommonModal/CommonModal.js";
import { BranchForm } from "../../forms/BranchForm/BranchForm.js";
import { useToast } from "../../context/ToastContext";
import { useNavigate } from "react-router-dom";

import { IoGrid } from "react-icons/io5";
import { FaTableList } from "react-icons/fa6";

import { useSearchResults } from "../../context/SearchResultsContext.js";

export const Branch = () => {
  const { role } = useAuth();
  const fileInputRef = useRef(null);
  const { searchResults, searchType } = useSearchResults();
  const [branch, setBranch] = useState([]);
  const [selectedBranchId, setSelectedBranchId] = useState(null);
  const { showLoading, hideLoading } = useLoading();
  const [error, setError] = useState(null);
  const { company } = useAuth();
  console.log(company, "companyyy")
  const companyID = company?._id;
  const [showModal, setShowModal] = useState({ visible: false, mode: "add" });
  const { showToast } = useToast();
  const navigate = useNavigate()
  const [viewMode, setViewMode] = useState("table");
  // State for edit modal
  const [editModal, setEditModal] = useState({ visible: false, branchId: null });
  useEffect(() => {
    const fetchBranches = async () => {
      try {
        showLoading();
        const response = await getallBranchNames(companyID);
        console.log(response.data, "response branch data")
        const data = response.data?.result?.branchData || [];
        setBranch(data);
        console.log(branch, "branchdata")
      } catch (error) {
        console.error("Error fetching branches:", error);
        showToast("Failed to fetch branches", "error");
      } finally {
        hideLoading();
      }
    };

    if (companyID) {
      fetchBranches();
    }
  }, [companyID]);
  // const handleFileChange = async (e) => {
  //   const file = e.target.files[0];
  //   if (!file || !selectedBranchId) return;

  //   try {
  //     showLoading();
  //     await uploadUsersSpreadsheet(selectedBranchId, file);
  //   } catch (err) {
  //     console.error(err);
  //   } finally {
  //     hideLoading();
  //     fileInputRef.current.value = ""; // Reset input
  //   }
  // };



  const processSearchResults = (results) => {
    if (!results || !Array.isArray(results)) return [];

    return results.map(note => ({
      _id: note._id,
      branchId: note.branchId,
      title: note.title,
      content: note.content,
      courtRef: note.courtRef,
      createdAt: note.createdAt,
      updatedAt: note.updatedAt,
      user: note.user,
    }));
  };
  const displayBranch = searchType === 'notes' && searchResults
    ? processSearchResults(searchResults)
    : branch;

  const isInSearchMode = searchType === 'notes';

  const getNoDataMessage = () => {
    return isInSearchMode
      ? "No Branches found matching your search."
      : "No Branches found. Start by creating a new one!";
  };

  const shouldShowNoDataMessage = () => {
    return isInSearchMode
      ? !searchResults || searchResults.length === 0
      : branch.length === 0;
  };




  const OpenBranchData = (branchId) => {
    navigate(`/home/branch/view/${branchId}`);
  }

  const handleEditBranch = (e, branchItem) => {
    e.stopPropagation();
    setEditModal({ visible: true, branchId: branchItem?._id });
  };

  // Handler for closing edit modal
  const handleCloseEditModal = () => {
    setEditModal({ visible: false, branchId: null });
  };

  // Handler for successful edit (refresh list if needed)
  const handleEditSuccess = () => {
    setEditModal({ visible: false, branchId: null });
    // Optionally, refresh branches here
    // You can call fetchBranches if you move it out of useEffect
    window.location.reload(); // Or trigger a state update to refresh
  };

  // Helper function to check if branch has members
  const hasMembers = (branchItem) => {
    return branchItem?.user && Array.isArray(branchItem.user) && branchItem.user.length > 0;
  };

  // Handler for the dynamic Add/Edit Members button
  const handleMembersAction = (e, branchItem) => {
    e.stopPropagation();
    setSelectedBranchId(branchItem?._id);
    const mode = hasMembers(branchItem) ? "edit" : "add";
    setShowModal({ visible: true, mode });
  };

  return (
    <>
      <div className="invoices-header">
        <div className="view-toggle-wrapper">
          <button
            className={`view-toggle-btn ${viewMode === "grid" ? "active" : ""}`}
            onClick={() => setViewMode("grid")}
          >
            <IoGrid />
          </button>
          <button
            className={`view-toggle-btn ${viewMode === "table" ? "active" : ""}`}
            onClick={() => setViewMode("table")}
          >
            <FaTableList />
          </button>
        </div>
      </div>

      <div className="branch-container">
        {shouldShowNoDataMessage() ? (
          <p className="no-branch-found">{getNoDataMessage()}</p>
        ) : viewMode === "grid" ? (
          <div className="branch-grid">
            {displayBranch.map((branchItem, index) => (
              <div key={index} className="branch-card" onClick={() => OpenBranchData(branchItem?._id)}>
                <div className="branch-header">
                  <div className="branch-title-wrapper">
                    <span className="branch-label">Branch {index + 1}</span>
                    <h2 className="branch-name">{branchItem?.branchName}</h2>
                  </div>

                  <div className="branch-actions">
                    {role !== 'lawyer' && (
                      <button className="branch-action-btn edit-branch" onClick={(e) => handleEditBranch(e, branchItem)}>
                        <BiEdit size={16} />
                      </button>
                    )}
                    <button
                      className="branch-action-btn members-action"
                      onClick={(e) => handleMembersAction(e, branchItem)}
                    >
                      {hasMembers(branchItem) ? "Edit Members" : "Add Members"}
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <table className="branch-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Branch Name</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {displayBranch.map((branchItem, index) => (
                <tr key={branchItem?._id} onClick={() => OpenBranchData(branchItem?._id)} style={{ cursor: 'pointer' }}>
                  <td>{index + 1}</td>
                  <td>{branchItem?.branchName}</td>
                  <td>
                    {role !== 'lawyer' && (
                      <button onClick={(e) => { e.stopPropagation(); handleEditBranch(e, branchItem) }} className="edit-btn">Update</button>
                    )}
                    <button
                      onClick={(e) => handleMembersAction(e, branchItem)}
                      className="members-btn"
                    >
                      {hasMembers(branchItem) ? "Edit Members" : "Add Members"}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>


      {showModal.visible && (
        <HierarchyModal
          branchId={selectedBranchId}
          mode={showModal.mode}
          onClose={() => setShowModal({ visible: false, mode: "add" })}
        />
      )}

      {/* Edit Branch Modal */}
      {editModal.visible && (
        <CommonModal onClose={handleCloseEditModal}>
          <BranchForm
            branchID={editModal.branchId}
            onClose={handleCloseEditModal}
            onSuccess={handleEditSuccess}
          />
        </CommonModal>
      )}


    </>


  );
};
